module.exports = "pegasus/assets/hexline-youtube.gif";